"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Craftsmanship() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const paragraphs = [{
    drop: "W",
    rest: "e founded MetalLine Exteriors in 2012, working from a single truck in Calgary’s unpredictable climate. We saw too many homes suffering from subpar materials and rushed installations that couldn't withstand our harsh winters. We asked ourselves: why should premium exterior protection be a luxury reserved for the few, rather than the standard for every homeowner?"
  }, {
    drop: "O",
    rest: "Our mission began in a small workshop, focusing on the precision of metal roofing and architectural cladding. We wanted to bridge the gap between industrial-grade durability and residential elegance. By sourcing the finest ACM panels and stone veneers, we created a process where every seam, every fastener, and every panel is installed with the eye of an engineer."
  }, {
    drop: "T",
    rest: "Today, MetalLine serves Calgary, Airdrie, and beyond with a team dedicated to the art of the exterior. Our workshop has grown, but our commitment to the 'Precision Edge' remains. Whether it's a custom standing seam roof or a complex architectural facade, we build for the next fifty years, not just the next season. Your home is our blueprint."
  }];
  return <section data-section-id="20576" id="our-craftsmanship-story" className="bg-background text-foreground relative overflow-hidden ![padding:30px_20px_30px_20px]">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-multiply" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div ref={sectionRef} className="relative mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {}
        <div className="lg:col-span-5 relative flex justify-center lg:justify-start">
          <div className="relative w-[80%] lg:w-full max-w-md" style={{
          transform: isVisible ? "rotate(0deg)" : "rotate(0deg)",
          transition: "transform 900ms cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            {}
            <div className="relative p-[2px] bg-primary" style={{
            borderRadius: "2px"
          }}>
              <div className="relative overflow-hidden bg-background" style={{
              aspectRatio: "4/5",
              borderRadius: "0px"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/metal_roofing_installation.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/metal_roofing_installation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/metal_roofing_installation.png-wvc-sizes" alt="MetalLine Exteriors team installing premium metal roofing on a Calgary residence" loading="lazy" decoding="async" className="w-full h-full object-cover" style={{
                filter: "contrast(1.05) brightness(0.95)"
              }} />
                {}
                <div className="pointer-events-none absolute inset-0 opacity-10 mix-blend-overlay" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23g)'/%3E%3C/svg%3E\")"
              }} />
              </div>
            </div>

            {}
            <div className="absolute -top-6 -left-4 md:-left-12 z-10" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(10px)",
            transition: "opacity 700ms ease-out 400ms, transform 700ms ease-out 400ms"
          }}>
              
            </div>

            {}
            <div className="absolute top-1/2 -right-4 md:-right-20 z-10 hidden sm:block" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(10px)",
            transition: "opacity 700ms ease-out 700ms, transform 700ms ease-out 700ms"
          }}>
              
            </div>

            {}
            <div className="absolute -bottom-8 right-2 md:right-8 z-10" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(10px)",
            transition: "opacity 700ms ease-out 1000ms, transform 700ms ease-out 1000ms"
          }}>
              
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-7 lg:pl-4">
          {}
          <div style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(18px)",
          transition: "all 620ms cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            <p className="text-primary mb-4 font-mono text-sm uppercase tracking-widest">OUR PHILOSOPHY</p>
          </div>

          {}
          <h2 className="font-default text-foreground mb-10 relative" style={{
          fontSize: "clamp(2rem, 1.2rem + 3.2vw, 3.5rem)",
          fontWeight: 600,
          letterSpacing: "-0.02em",
          lineHeight: 1.1,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(18px)",
          transition: "all 620ms cubic-bezier(0.22, 1, 0.36, 1) 80ms"
        }}>
            Engineering the{" "}
            <span className="relative inline-block text-primary">
              future of
            </span>{" "}
            Calgary exteriors.
          </h2>

          {}
          <div className="space-y-6 max-w-[58ch]">
            {paragraphs.map((para, i) => <p key={i} data-index={i} className="text-foreground/80" style={{
            fontFamily: "var(--font-sans)",
            fontSize: "clamp(1rem, 1rem + 0.1vw, 1.125rem)",
            lineHeight: 1.6,
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(18px)",
            transition: `all 620ms cubic-bezier(0.22, 1, 0.36, 1) ${200 + i * 120}ms`
          }}>
                <span style={{
              fontFamily: "var(--font-default)",
              fontSize: "2.5rem",
              fontWeight: 700,
              color: "var(--primary)",
              float: "left",
              lineHeight: 0.9,
              marginRight: "0.75rem",
              marginTop: "0.2rem",
              display: "inline-block",
              transform: isVisible ? "scale(1)" : "scale(0.85)",
              transition: `transform 700ms cubic-bezier(0.22, 1, 0.36, 1) ${400 + i * 120}ms`
            }}>
                  {para.drop}
                </span>
                {para.rest}
              </p>)}
          </div>

          {}
          <div className="mt-10" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(18px)",
          transition: "all 620ms cubic-bezier(0.22, 1, 0.36, 1) 700ms"
        }}>
            <Link to="/ContactPage" className="group inline-flex items-center gap-2 text-foreground text-primary hover:text-primary transition-colors duration-220">
              <span className="relative font-mono text-sm uppercase tracking-widest font-bold">
                Get a quote
              </span>
              <ArrowRight className="size-4 text-primary transition-transform duration-220 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}